import { render } from "./SmartColumn.vue?vue&type=template&id=8095974c&scoped=true"
import script from "./SmartColumn.vue?vue&type=script&lang=js"
export * from "./SmartColumn.vue?vue&type=script&lang=js"

import "./SmartColumn.vue?vue&type=style&index=0&id=8095974c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8095974c"]])

export default __exports__